export default __webpack_public_path__ + "static/media/partners_group_2.20713281.png";